import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { ItemCategoryDropDownDto, ItemsDropDownDto, ItemSubCategoryDropDownDto, SizesDropDownDto } from "@gtpl/shared-models/masters";
import { ApiProperty } from "@nestjs/swagger";

export class BomPackingItemsDto {
    @ApiProperty()
    itemCategoryDetails:ItemCategoryDropDownDto;
    @ApiProperty()
    itemSubCategoryDetails:ItemSubCategoryDropDownDto;
    @ApiProperty()
    itemDetails:ItemsDropDownDto;
    @ApiProperty()
    size:SizesDropDownDto;
    @ApiProperty()
    quantity:number;
    @ApiProperty()
    poQuantity?:number;
    @ApiProperty()
    grnQuantity?:number;
    @ApiProperty()
    existingQuantity?:number;
    @ApiProperty()
    status:string;
    @ApiProperty()
    packingCategory:string;
    @ApiProperty()
    isActive:boolean;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    createdUser? : string;
    @ApiProperty()
    updatedUser? : string;
    @ApiProperty()
    packingMaterialId?:number;
    @ApiProperty()
    isRequired?:GlobalStatus;
    @ApiProperty()
    isActiveRevised?:GlobalStatus;
    @ApiProperty()
    isQtyRevised?:GlobalStatus;

    /**
     * 
     * @param itemCategoryDetails 
     * @param itemDetails 
     * @param size 
     * @param quantity 
     * @param status 
     * @param saleOrderId 
     * @param createdUser 
     * @param updatedUser 
     * @param packingMaterialId 
     */
    constructor(itemCategoryDetails:ItemCategoryDropDownDto, itemDetails:ItemsDropDownDto, itemSubCategoryDetails:ItemSubCategoryDropDownDto, size:SizesDropDownDto, quantity:number,packingCategory:string,isActive:boolean,status:string, saleOrderId?:number, createdUser? : string, updatedUser? : string, packingMaterialId?:number, poQuantity?:number, grnQuantity?:number,existingQuantity?:number){
        this.itemCategoryDetails = itemCategoryDetails;
        this.itemSubCategoryDetails = itemSubCategoryDetails;
        this.itemDetails = itemDetails;
        this.size = size;
        this.quantity = quantity;
        this.packingCategory = packingCategory;
        this.isActive = isActive;
        this.status = status;
        this.saleOrderId = saleOrderId;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.packingMaterialId = packingMaterialId;
        this.poQuantity = poQuantity;
        this.grnQuantity = grnQuantity;
        this.existingQuantity = existingQuantity;
    }
}